<ng-container *transloco="let t">
    <app-account-stepper>
        <cdk-step>
            <app-preferred-language
                (language)="languageChosen($event)"
            ></app-preferred-language>
        </cdk-step>

        <cdk-step>
            <app-age (age)="ageRangeChosen($event)" (back)="goBack()"></app-age>
        </cdk-step>

        <cdk-step>
            <app-account-setup
                (accountInfo)="accountInfoSet($event)"
                (back)="goBack()"
            ></app-account-setup>
        </cdk-step>

        <cdk-step>
            <app-account-verification
                [header]="t('auth.account-creation.accountVerificationHeader')"
                [continueText]="
                    t('auth.account-creation.accountVerificationContinueText')
                "
                (codeProvided)="codeProvided($event)"
                (back)="goBack()"
            ></app-account-verification>
        </cdk-step>
    </app-account-stepper>
</ng-container>
